import { Pressable } from 'react-native';

import type { PressableProps, ViewStyle } from 'react-native';

export type BasePressableProps = Pick<
  PressableProps,
  'onPress' | 'children' | 'hitSlop' | 'disabled' | 'style' | 'onLayout'
> &
  Pick<ViewStyle, 'backgroundColor'>;

export const BasePressable = (props: BasePressableProps) => {
  const {
    children,
    style,
    onPress,
    disabled,
    backgroundColor,
    hitSlop,
    onLayout,
  } = props;

  return (
    <Pressable
      onLayout={onLayout}
      onPress={onPress}
      disabled={disabled}
      hitSlop={hitSlop}
      style={({ pressed, ...rest }) => [
        {
          backgroundColor: backgroundColor,
        },
        pressed && !disabled
          ? {
              opacity: 0.7,
            }
          : null,
        typeof style === 'function' ? style({ pressed, ...rest }) : style,
      ]}
    >
      {children}
    </Pressable>
  );
};
